<template>
	<div class="header-ope">
		<div class="title">
			<div class="first-header">{{ schoolBaseInfo.examName }}</div>
			<div class="second-header">
				命题质量分析报告 <span v-show="subjectName">( {{ subjectName }} )</span>
			</div>
			<div class="over-view" v-show="isShowOpeBtn" @click="headerBtn" v-text="isViewState ? '下 载' : '预 览'"></div>
		</div>
		<div class="info">
			<p class="info-detail" v-if="query.schoolId">
				<strong>{{ schoolBaseInfo.schoolName }}</strong>
				本次考试 （考试时间： {{ schoolBaseInfo.examDate }}），<strong>{{ schoolBaseInfo.gradeName }}</strong> 共
				<strong>{{ schoolBaseInfo.classNum }}</strong>
				个班级， <strong>{{ schoolBaseInfo.totalNum }}</strong> 名学生参加考试。 考试学科：<strong>{{ schoolBaseInfo.subjectInfo }}</strong
				>，共<strong> {{ schoolBaseInfo.subjectNum }}</strong> 门学科。
			</p>
			<p class="info-detail" v-else>
				本次联考（考试时间： {{ schoolBaseInfo.examDate }}），<strong>{{ schoolBaseInfo.gradeName }}</strong> 共
				<strong>{{ schoolBaseInfo.schoolNum }}</strong>
				个学校， 共<strong>{{ schoolBaseInfo.totalNum }}</strong> 名学生参加考试。 考试学科：<strong>{{ schoolBaseInfo.subjectInfo }}</strong
				>，共<strong> {{ schoolBaseInfo.subjectNum }}</strong> 门学科。
			</p>
		</div>
		<div class="subject-list" v-if="isShowTab" ref="tabOpe" :class="{ 'fix-table-title': fixState }">
			<el-tabs v-model="tabActive" @tab-click="tabHandleClick">
				<el-tab-pane :label="item.name" :name="item.id" v-for="item in tabInfo" :key="item.id"></el-tab-pane>
			</el-tabs>
		</div>
		<slot />
	</div>
</template>

<script>
export default {
	name: 'report-header',
	data() {
		return {
			tabActive: null,
			tabInfo: [],
			fixState: false,
			query: this.$route.query
		}
	},
	props: {
		schoolBaseInfo: {
			type: Object,
			default: () => {}
		},
		isShowOpeBtn: {
			type: Boolean,
			default: true
		},
		isShowTab: {
			type: Boolean,
			default: true
		},
		isViewState: {
			type: Boolean,
			default: false
		},
		headerTabInfo: {
			type: Object,
			default: () => {}
		},
		subjectName: {
			type: String,
			default: ''
		},
		scrollTop: {
			type: Number,
			default: 0
		}
	},
	watch: {
		headerTabInfo: {
			handler(val) {
				if (val?.headerList.length > 0) {
					this.tabInfo = val.headerList
					this.tabActive = val.tabActiveVal
				}
			},
			immediate: true,
			deep: true
		}
	},
	methods: {
		headerBtn() {
			this.$emit('headerBtn')
		},
		tabHandleClick(val) {
			this.$emit('tabHandleClick', { tabActive: this.tabActive, label: val.label })
		}
	}
}
</script>

<style scoped lang="less">
.header-ope {
	width: 100%;
	.fix-table-title {
		position: fixed;
		top: 0;
	}
	.subject-list {
		padding: 0 15px;
		height: 60px;
		display: flex;
		align-items: center;
		background: white;
		border-top: 1px solid #e5e5e5;
		border-bottom: 1px solid #e5e5e5;
		box-sizing: border-box;
		margin-bottom: 15px;
		.subject {
			font-size: 16px;
			color: #909399;
			padding: 0 40px;
		}
	}
	.title {
		background: #009688;
		color: white;
		text-align: center;
		border-top-left-radius: 5px;
		border-top-right-radius: 5px;
		position: relative;
		.first-header {
			font-size: 28px;
			padding-top: 35px;
		}
		.second-header {
			font-size: 20px;
			padding-top: 5px;
			padding-bottom: 35px;
		}
		.over-view {
			position: absolute;
			right: 20px;
			top: 50%;
			transform: translateY(-50%);
			padding: 8px 30px;
			background: white;
			color: #009688;
			border-radius: 25px;
			&:hover {
				cursor: pointer;
			}
		}
		@media print {
			.first-header {
				font-size: 36px;
			}
			.second-header {
				font-size: 28px;
			}
		}
	}
	.info {
		padding: 30px 15px;
		background: white;
		box-sizing: border-box;
		.info-detail {
			font-size: 15px;
			color: black;
			&:nth-child(2) {
				padding-top: 20px;
			}
		}
		@media print {
			.info-detail {
				font-size: 25px;
			}
		}
	}
	/deep/.el-tabs__item.is-active {
		color: #009688;
	}
	/deep/.el-tabs__active-bar {
		background-color: #009688;
	}
}
</style>
